import { useContext } from 'react';
import { Button, ButtonGroup, useMediaQuery, useTheme } from '@mui/material';
import { AppContext } from '../all';

type Props = {
    selectedMonths?: number[];
    tinyLabels?: boolean;
    size?: 'small' | 'medium' | 'large';
    onChangeMonth: (month: number) => void;
    contract?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | null;
};

/**
 * Button months
 *
 * Props
 *
 *     * integer month: 1 = january, etc
 *     * integer[] selectedMonths: selected months, 1=january, etc.
 *     * boolean multipleSelection
 *     * boolean tinyLabels: show only the first letter of every month.
 *     * string size: size of buttons (small)
 *     * function onChangeMonth(month): when THE month (1=january) is changed (not multiple choices). January = 1, etc.
 *     * string contract: breakpoint at which the component will render as 2 rows one on top of the other
 */
export function SttButtonMonths({
    selectedMonths = [],
    tinyLabels = false,
    size,
    onChangeMonth,
    contract = null,
}: Props): React.ReactElement {
    const cxt = useContext(AppContext)!;
    const theme = useTheme();
    const matchQuery = useMediaQuery(theme.breakpoints.down(contract || 'xl'));

    // Render
    return (
        <>
            {cxt?.constants?.months &&
                (contract &&
                matchQuery /* Si la pantalla es muy estrecha, sencillamente lo pintamos en dos filas, con la mitad de meses en cada una */ ? (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'stretch',
                        }}
                    >
                        <ButtonGroup size={size}>
                            {cxt.constants.months
                                .slice(0, 6)
                                .map((month: any) => (
                                    <Button
                                        key={month.id}
                                        style={{ flex: 1 }}
                                        variant={
                                            selectedMonths.find(
                                                (id: any) => id === month.id,
                                            )
                                                ? 'contained'
                                                : 'outlined'
                                        }
                                        color={
                                            selectedMonths.find(
                                                (id: any) => id === month.id,
                                            )
                                                ? 'primary'
                                                : undefined
                                        }
                                        onClick={() => onChangeMonth(month.id)}
                                    >
                                        {tinyLabels ? month.tiny : month.short}
                                    </Button>
                                ))}
                        </ButtonGroup>
                        <ButtonGroup size={size} style={{ marginTop: 8 }}>
                            {cxt.constants.months
                                .slice(6, 12)
                                .map((month: any) => (
                                    <Button
                                        key={month.id}
                                        style={{ flex: 1 }}
                                        variant={
                                            selectedMonths.find(
                                                (id: any) => id === month.id,
                                            )
                                                ? 'contained'
                                                : 'outlined'
                                        }
                                        color={
                                            selectedMonths.find(
                                                (id: any) => id === month.id,
                                            )
                                                ? 'primary'
                                                : undefined
                                        }
                                        onClick={() => onChangeMonth(month.id)}
                                    >
                                        {tinyLabels ? month.tiny : month.short}
                                    </Button>
                                ))}
                        </ButtonGroup>
                    </div>
                ) : (
                    <ButtonGroup size={size}>
                        {cxt.constants.months.map((month: any) => (
                            <Button
                                key={month.id}
                                variant={
                                    selectedMonths.find(
                                        (id: any) => id === month.id,
                                    )
                                        ? 'contained'
                                        : 'outlined'
                                }
                                color={
                                    selectedMonths.find(
                                        (id: any) => id === month.id,
                                    )
                                        ? 'primary'
                                        : undefined
                                }
                                onClick={() => onChangeMonth(month.id)}
                            >
                                {tinyLabels ? month.tiny : month.short}
                            </Button>
                        ))}
                    </ButtonGroup>
                ))}
        </>
    );
}
